import script from "./CertificateGenerate.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateGenerate.vue?vue&type=script&setup=true&lang=js"

import "./CertificateGenerate.vue?vue&type=style&index=0&id=65d98f27&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d98f27"]])

export default __exports__